<div class="{{ui}} buttons">
  {{>slot}}
</div>
